import axios from 'axios';
import set from 'lodash/set';
axios.defaults.baseURL = process.env.REACT_APP_API_URL;

const addAuthorizationToHeaders = async (config, store) => {
  const { session } = store.getState();
  if (session.token) {
    set(config, 'headers.authorization', session.token);
    return config;
  }
  return config;
};

const authorizationProvider = (store) => {
  // axios.interceptors.request.use((config) => addAuthorizationToHeaders(config, store));

  // Add a response interceptor
  axios.interceptors.response.use((response) =>
    // Do something with response data
     response.data, (error) => {
    // Do something with response error
    if (error.response) {
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error);
  });
};

export default authorizationProvider;
